/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Execute_Detail7Inputs */

const en_svc_ai_image_pod_automation_execute_detail7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate, mock up and list in bulk.`)
};

const ar_svc_ai_image_pod_automation_execute_detail7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ولّد وصمم وانشر بكميات.`)
};

const bn_svc_ai_image_pod_automation_execute_detail7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রচুর তৈরি করুন, মকআপ করুন আর তালিকাভুক্ত করুন।`)
};

const de_svc_ai_image_pod_automation_execute_detail7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Masse generieren, mocken und listen.`)
};

const es_svc_ai_image_pod_automation_execute_detail7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar, maquetar y publicar en masa.`)
};

const fr_svc_ai_image_pod_automation_execute_detail7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générez, maquettisez et publiez en masse.`)
};

const pt_svc_ai_image_pod_automation_execute_detail7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar, maquetar e publicar em massa.`)
};

const zh_svc_ai_image_pod_automation_execute_detail7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量生成、做图、上架。`)
};

const tr_svc_ai_image_pod_automation_execute_detail7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topluca üret, maketle, listele.`)
};

const ru_svc_ai_image_pod_automation_execute_detail7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Генерируйте, мокапьте и публикуйте массово.`)
};

const pl_svc_ai_image_pod_automation_execute_detail7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generuj, mockupuj i listuj masowo.`)
};

/**
* | output |
* | --- |
* | "Generate, mock up and list in bulk." |
*
* @param {Svc_Ai_Image_Pod_Automation_Execute_Detail7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_execute_detail7 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Execute_Detail7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Execute_Detail7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_execute_detail7(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_execute_detail7(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_execute_detail7(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_execute_detail7(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_execute_detail7(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_execute_detail7(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_execute_detail7(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_execute_detail7(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_execute_detail7(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_execute_detail7(inputs)
	return en_svc_ai_image_pod_automation_execute_detail7(inputs)
});
export { svc_ai_image_pod_automation_execute_detail7 as "svc_ai-image-pod-automation_EXECUTE_detail" }